  <div class="loading-spinner">
    <i class="far fa-spinner-third fa-spin fa-2x"></i>
  </div>
  <div style="position:absolute; top: 60%; text-align: center; width: 100%;">
    <div *ngIf="messageVisible">{{timeoutMessage | translate}}</div>
  </div>
